// Importing countries
import { COUNTRIES_ES } from './countries';

export const LANG_ES_CODE = 'es-ES';
export const LANG_ES_NAME = 'Esp';
export const LANG_ES_COMPLETE_NAME = 'Español';
// ==== SUPPORTED LANGUAGES ====
// =============================
const LANG_ES = {
  'en-US': 'English',
  'es-ES': 'Español',
  'da-DA': 'Dansk',
  'fr-FR': 'Français',
  'fr-CA': 'Français (Canada)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'ENGLISH': 'English',
  'SPANISH': 'Español',
  'DANISH': 'Dansk',
  'FRENCH': 'Français',
  'CANADIAN FRENCH': 'Français (Canada)',
  'GERMAN': 'Deutsch',
  'DUTCH': 'Nederlands',
  'MORE_INFO': 'Más información',
  // =========== LOGIN ===========
  // =============================
  'HOME': {
    'TITLE': 'Conocimiento Grupal es Poder',
    'TEXT': 'Concept Systems Incorporated trae a las organizaciones que trabajan en cualquier iniciativa de colaboración procesos superiores para capturar la sabiduría del grupo desde diferentes puntos de vista.'
  },
  'AUTO_LOGOUT': {
    'WARNING': {
      'TITLE': '¿Sigue ahí?',
      'BUTTON': 'Seguir trabajando.',
      'MESSAGE': 'Por razones de seguridad, le cerramos la sesión si sigue inactivo después de ',
      'SECONDS': 'segundos'
    }
  },
  'LOGIN': {
    'USERNAME': 'Nombre de usuario',
    'USERNAME_OR_EMAIL': 'NOMBRE DE USUARIO O CORREO ELECTRÓNICO',
    'OR': 'o',
    'ACTIVATE_ACCOUNT': 'Activar la cuenta',
    'ACTIVATE_ACCOUNT_TEXT': '¡Cree una cuenta, empiece a contribuir a proyectos de investigación importantes y diviértase al mismo tiempo!',
    'ASSIGNED_USERNAME': 'SU NOMBRE DE USUARIO',
    'YOUR_USERNAME': 'SU NOMBRE DE USUARIO',
    'ANONYMOUS_ACCOUNT': 'Cuenta anónima',
    'DIFFERENT_EMAIL': 'Prefiero usar una dirección de correo electrónico diferente.',
    'PASSWORD': 'CONTRASEÑA',
    'FORGOT_PASSWORD': '¿Contraseña olvidada?',
    'LOCKED_ACCOUNT': '*Su cuenta se bloqueó. Favor de ponerse en contacto con el equipo de apoyo del proyecto.',
    'INVALID_USER': 'Nombre de usuario inválido o contraseña inválida. Vuelva a intentar o póngase en contacto con el equipo de apoyo del proyecto.',
    'WRONG_PASSWORD_1': '¡Contraseña incorrecta! Le queda un intento más.',
    'WRONG_PASSWORD': '¡Contraseña incorrecta! Le quedan ',
    'MORE_TRIES': ' intentos más.',
    'RESET_PASSWORD': 'Restablecer contraseña.',
    'DONE': 'COMPLETADO',
    'INVITE_PROMPT': 'Te han invitado a participar en un nuevo proyecto.',
    'INVITE_PROCEED': 'proceder al proyecto',
    'HAVE_ACCOUNT': '¿Ya tiene una cuenta?',
    'ASSIGNED_ACCOUNT': 'Si tiene un nombre de usuario y contraseña ASIGNADOS,',
    'ASSIGNED_LINK': 'HAGA CLIC AQUÍ',
    'LOGIN_HERE': 'Iniciar sesión aquí',
    'RESET_EXPIRE': 'El enlace para restablecer su contraseña se expiró. Favor de solicitar un nuevo enlace de abajo para restablecer su contraseña.',
    'RESEND': 'REENVIAR',
    'PWD_CONFIRMATION': 'Confirmación de la nueva contraseña',
    'PDW_CHANGE_SUCCESSFULLY': 'Su contraseña se cambió con éxito.',
    'CONTINUE': 'CONTINUAR',
    'CREATE_PASSWORD': 'Crear una contraseña.',
    'CREATE_ACCOUNT': 'Crear una cuenta.',
    'CP_SUBTITLE': 'Establecer una contraseña para una cuenta anónima.',
    'CP_SUBTITLE_USERNAME': 'Establecer una contraseña para un nombre de usuario asignado.',
    'CP_SUBTITLE_EMAIL': 'Establecer una contraseña para su correo electrónico.',
    'ANONYMOUS_SUGGESTION_TEXT': 'Le sugerimos encarecidamente que escriba esta información y guárdela en un lugar seguro.',
    'WHY': '¿Por qué?',
    'CONFIRM_PASSWORD': 'CONFIRMAR LA CONTRASEÑA',
    'LOG_IN': 'Iniciar sesión',
    'FINISH_SU_ACCOUNT': 'Finalizar la configuración de cuenta',
    'EMAIL': 'CORREO ELECTRÓNICO',
    'CHECK_INBOX': 'Revisar la bandeja de entrada de su correo electrónico',
    'EMAIL_TEXT_NOTIFICATION': 'Hemos enviado un correo electrónico a',
    'EMAIL_TEXT_NOTIFICATION_2': 'con un enlace para activar su cuenta.',
    'CLICK_LINK': '¡Haga clic en el enlace y ya está listo!',
    'BACK_LOGIN': 'Volver a iniciar sesión.',
    'SEND_EMAIL_TEXT_NOTIFICATION': 'Le enviaremos instrucciones para restablecer su contraseña a esta dirección de correo electrónico:',
    'FP_EMAIL_TEXT_NOTIFICATION': '¡Un correo electrónico está en camino! Pronto recibirá instrucciones para restablecer su contraseña. Asegúrese de que no llegue a su carpeta spam.',
    'DIDNT_GET_EMAIL': '¿No recibió las instrucciones por correo electrónico?',
    'RESEND_LINK': 'Volver a enviarme el enlace.',
    'RESET_PASSWORD_SUCCESS': 'Favor de ponerse en contacto con su equipo de apoyo del proyecto para restablecer su contraseña.',
    'NO_ACTIVITIES': {
      'OOPS': '¡Uy, perdón!',
      'TEXT_MAIN': 'Parece que el proyecto ha alcanzado el número necesario de contribuyentes.<br><br> You can ' +
        'Si tiene alguna pregunta, no dude en ponerse en contacto con el <a href="mailto:support@conceptsystems.com">administrador del proyecto</a>',
      'TEXT_NO_ACTIVITIES': 'No se encuentra ninguna actividad abierta que se relacione con este enlace de invitación.<br><br> Se puede ponerse en contacto con el administrador del proyecto si hay dudas.',
    },
    'INFO_REGISTER_IDENTIFIER': 'Los administradores del proyecto podrán enviarle un correo electrónico por el sistema según su condición de participante, pero no podrán ver su dirección de correo electrónico ni vincularla con su identificador.',
    'BROKEN_LINK': {
      'INFORMATION': 'Información:',
      'PROJECT_CONTACT': 'Contacto del proyecto:',
      'CAUSE': 'El enlace empleado se ha roto, favor de repasar el enlace original e inténtalo otra vez.',
      'TEXT': 'Si tiene alguna pregunta, no dude en ponerse en contacto con el adminstrador del proyecto.',
    },
    'CERATE_ACCOUNT': 'CREAR UNA CUENTA',
    'CREATE_ACCOUNT_IDENTIFIER': {
      'TITLE_CREATE': 'Cree una cuenta',
      'TITLE_START': 'y empiece a contribuir sus ideas.',
      'STUDENT_ID': 'IDENTIFICACIÓN DE ESTUDIANTE',
      'EMAIL': 'DIRECCIÓN DE CORREO ELECTRÓNICO',
      'EMAIL_INFO': 'Su correo electrónico no será visible al equipo del proyecto.',
      'CREATE_A_PASSWORD': 'CREAR UNA CONTRASEÑA',
      'STRONG': 'Fuerte',
      'WEAK': 'Débil',
      'INVALID_USERNAME': 'Nombre de usuario inválido, inténtalo otra vez.',
      'INCOMPLETE_USERNAME': 'Debe introducir un nombre de usuario.',
      'USERNAME': 'Nombre de usuario',
      'CHARACTERS_MINIMUM': 'La contraseña debe tener un mínimo de seis caracteres.',
      'SAME_USERNAME': 'La contraseña no puede ser igual al nombre de usuario.',
      'MISSING_DIGIT': 'Su contraseña debe tener al menos un número.',
      'MISSING_UPPERCASE': 'Su contraseña debe tener al menos una letra mayúscula.',
      'MISSING_LOWERCASE': 'Su contraseña debe tener al menos una letra minúscula.',
      'MISSING_SYMBOL': 'Su contraseña debe tener al menos un carácter no alfabético.',
      'PASSWORD_MAX': 'Debe introducir una contraseña.',
      'PASSWORD_PLACEHOLDER': 'Introduzca su contraseña.',
      'SECURE_PASSWORD': 'Una contraseña segura debe incluir por lo menos:',
      'BASE_DIGIT': 'un número (0 hasta 9)',
      'UPPERCASE_CHARACTER': 'un carácter en mayúscula (A hasta Z)',
      'LOWERCASE_CHARACTER': 'un carácter en minúscula (a hasta z)',
      'ALPHABETIC_CHARACTER': 'un carácter no alfabético (por ejemplo, !, $, %, #)',
      'MUST_PASSWORD_AGAIN': 'Debe introducir la contraseña otra vez.',
      'PASSWORD_NOT_MATCH': 'Las contraseñas no coinciden.',
      'PASSWORD_AGAIN': 'EIntroduzca su contraseña otra vez.',
    }
  },
  // ========= AUTOSAVE ==========
  // =============================
  'SAVING_STATUS': {
    'SAVED': 'Cambios se guardaron.',
    'SAVING': 'Guardando datos',
  },
  // ==== MY PROJECTS ===========
  // ============================
  'MY_PROJECTS': {
    'TITLE': 'Mis proyectos',
    'TEXT': 'Haga clic en un proyecto para completar las actividades asignadas.',
    'NO_PROJECT': {
      'TITLE': '¡Uy, perdón!',
      'TEXT': 'Actualmente no se le ha asignado ninguna actividad del proyecto.',
    }
  },
  // ==== SYSTEM ERROR ===========
  // ============================
  'SYSTEM_ERROR': {
    'TITLE': 'Error sistémico inesperado',
    'MESSAGE': {
      'TITLE': '¡Uy, perdón!',
      'TEXT': 'Se ocurrió un error sistémico inesperado. Favor de intentarlo otra vez dentro de unos momentos. Si el error persista, póngase en contact con ',
      'EMAIL': 'support@conceptsystems.com',
    }
  },
  // ==== MY ACCOUNT ===========
  // ============================
  'MY_ACCOUNT': {
    'TITLE': 'Mi cuenta',
    'INFORMATION': 'Información de cuenta',
    'USERNAME': 'Nombre de usuario',
    'EMAIL': 'Correo electrónico',
    'PERSONAL_DETAILS': 'Datos personales',
    'FIRST_NAME': 'NOMBRE',
    'EDIT': 'EDITAR',
    'SAVE': 'GUARDAR',
    'LAST_NAME': 'APELLIDO',
    'CHANGE_PASSWORD': 'Cambiar la contraseña',
    'DONT_SEND_EMAIL': 'No envíeme comunicación electrónica de GroupWisdom<sup>tm</sup>',
    'CURRENT_PASSWORD': 'Contraseña actual',
    'NEW_PASSWORD': ' Nueva contraseña',
    'CONFIRM_PASSWORD': 'Confirme la contraseña.',
    'CHANGED': 'Cambiada:',
    'ANONYMOUS_ACCOUNT': 'Cuenta anónima',
    'TERMS': {
      'SHOW': 'Mostrar en la pantalla',
      'LABEL': 'Término groupwisdom<sup>tm</sup>'
    },
    'PRIVACY': {
      'SHOW': 'Mostrar en la pantalla',
      'LABEL': 'Privacidad groupwisdom<sup>tm</sup>'
    },
    'ANONYMOUS_TOOLTIP': 'El equipo del proyecto no conoce las identidades de cuentas anónimas.'
  },
  // ==== HEADER  =================
  // =============================
  'HEADER': {
    'MY_PROJECTS': 'Proyectos',
    'MY_ACCOUNT': 'Cuenta',
    'NOTIFICATIONS': 'Notificaciones',
    'HELP_AND_SUPPORT': 'Ayuda y apoyo',
    'SIGN_OUT': 'Cierre la sesión',
    'CHOSE_LANGUAGE': 'Seleccione el idioma:'
  },
  // ==== FOOTER =================
  // =============================
  'FOOTER': {
    'ITEMS': {
      'PRIVACY': 'Privacidad',
      'TERMS': 'Términos',
      'HELP': 'Ayuda & Apoyo'
    },
    'COPYRIGHT': 'Copyright © 2000-2023. Todo los derechos reservados. Con tecnología de',
    'COPYRIGHT_STRING': 'Concept Systems, Inc'
  },
  // ==== NOTIFICATIONS =================
  // =============================
  'NOTIFICATIONS': {
    'TITLE' : 'NOTIFICACIONES',
    'TITLE_NO' : 'NINGUNA NUEVA NOTIFICACIÓN',
    'TITLE_SINGLE' : 'UNA NUEVA NOTIFICACIÓN',
    'TITLE_MULTIPLE' : 'NUEVAS NOTIFICACIONES',
    'ALL': 'TODAS LAS NOTIFICACIONES',
    'PAGER': {
      'SHOWING': 'MOSTRANDO',
      'TO' : 'A',
    },
    'NOTIFICATION': 'Notificación',
    'FROM': 'De: ',
  },
  // ==== INFORMED CONSENT MODAL ===========
  // =======================================
  'INFORMED_CONSENT_MODAL': {
    'TITLE': 'Consentimiento para participar',
    'DOWNLOAD': 'Descargar el formulario de consentimiento',
    'UPLOAD': 'Subir el formulario de consentimiento firmado',
    'TOOLTIP': 'Firmar el formulario de consentimiento y súbalo para seguir participando en el proyecto.',
    'ACCEPT': 'ACEPTAR',
    'DECLINE': 'RECHAZAR',
    'FILE_ERROR': {
      'TYPE': 'Solo se puede subir el formulario de consentimiento en forma .pdf, .doc, .docx.',
      'SIZE': 'El límite de tamaño del archivo es 10MB, inténtalo otra vez.',
    },
    'NO_DATA': 'Los datos sobre el consentimiento para participar no han sido recibidos.'
  },
  // ==== THANK YOU MODAL ===========
  // =======================================
  'THANK_YOU_MODAL': {
    'BUTTON_LINK': 'SIGUIENTE'
  },
  // ==== DECLINE INFORMED CONSENT MODAL ========
  // ============================================
  'DECLINE_ICM': {
    'TITLE': 'Ud. ha rechazado',
    'TEXT': 'No se puede avanzar a las actividades del proyecto sin aceptar los términos y condiciones de consentimiento para participar.',
    'TEXT_1': 'Si tiene alguna pregunta, no dude en ponerse en contacto con el equipo del proyecto.',
    'CONTINUE': 'SEGUIR',
    'SING_OUT': 'Cerrar la sesión'
  },
  // ====== PROJECT ===========================
  // ==========================================
  'PROJECT': {
    'SHOW_PI': 'Mostrar información del proyecto',
    'VIEW_IC': 'Ver el formulario de consentimiento para participar',
    'AVAILABLE_ACTIVITIES': 'SUS ACTIVIDADES DISPONIBLES',
    'AVAILABLE_ACTIVITIES_TOOLTIP': 'Seleccione cualquier casilla de actividad, puede ser abierta, empezada o completada, para introducir y ' +
      'modificar elementos relacionados con dicha actividad. Cuando una actividad no ha sido introducida previamente, aparece como "open/abierto". Cuando una actividad ' +
      'ha sido introducida, aparece como "started/empezado" hasta ser completada. "Completed/completado" ' +
      ' no se aparece hasta que todas los elementos relacionados hayan sido completados o hasta que se ha seleccionado "completed/completado."',
    'PROJECT_INFO_MODAL': {
      'TITLE': 'Información de contacto del proyecto',
      'PHONE': 'Número de teléfono:',
      'EMAIL': 'Dirección de correo electrónico',
      'NO_DATA': 'Este proyecto carece de información de contacto.'
    },
    'PREVIEW': {
      'EXIT_TITLE': 'Está en la vista previa como participante.',
      'EXIT_BUTTON': 'Salir del modo de vista previa.'
    },
    'NO_ACTIVITIES': {
      'OOPS': '¡Uy, perdón!',
      'TEXT_MAIN': 'Parece que el proyecto ha alcanzado el número necesario de contribuyentes.  ' +
        'Puede contactar con el administrador del proyecto',
      'TEXT': 'Ninguna actividad asignada.'
    },
    'BRAINSTORMING': 'Lluvia De Ideas',
    'SORTING': 'Ordenamiento',
    'RATING': 'Calificación',
    'PQ': 'Preguntas para los participantes',
    'CLOSES': 'Cerrar'
  },
  // ==== BRAINSTORMING ========
  // ============================================
  'BRAINSTORMING': {
    'TITLE': 'Lluvia De Ideas',
    'INFO': 'Información',
    'INFORMATION': 'Reflexione seriamente sobre sus ideas. Se puede agregar muchos de sus pensamientos e ideas de áreas, ámbitos y experiencias diferentes pero relacionados con el tema.',
    'ADD_IDEAS': 'Agregar ideas',
    'COLLECTED_STATEMENTS': 'Declaraciones recogidas:',
    'COLLECTED_STATEMENTS_TOOLTIP': 'Estas son las declaraciones recogidas de todos los participantes de la sesión brainstorming. La lista se refresca cada vez que se agregue una declaración o se haga clic en refrescar.',
    'REFRESH': 'Refrescar la lista',
    'FINISH': 'Terminar',
    'STATEMENTS': {
      'ADD': 'Agregar declaración',
      'NEW_STATEMENT_PLACEHOLDER': 'Teclear para agregar una idea',
    },
    'ACTIONS': {
      'SEARCH': {
        'PLACEHOLDER': 'Buscar',
      }
    },
    'FOCUS_PROMPT': 'LA PREGUNTA DE ENFOQUE',
    'MOBILE_STATEMENTS': 'declaraciones',
    'COLLECTED': 'recogidas',
    'FOCUS_PROMPT_TOOLTIP': 'En este contexto esta frase o pregunta es el tema del grupo focal del proyecto. ' +
      'El objetivo es generar ideas para crear el contenido del proyecto.',
    'HIDE_PROMPT': 'Ocultar la pregunta de enfoque',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Mostrar introducción',
      'SHOW_TOUR_AGAIN': 'Mostrar el tour otra vez',
      'LEAVE': 'Salir del lluvia de ideas',
      'FINISH': 'Completar lluvia de ideas'
    },
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'EMPEZAR'
      },
      'LIMIT': {
        'TITLE': 'Límite del lluvia de ideas alcanzado',
        'DESCRIPTION': 'El límite de objetivos del proyecto ha sido alcanzado. No se puede agregar más.',
        'BUTTON': 'CERRAR'
      }
    },
    'PROJECT_HOME': 'Página principal del proyecto',
    'RETURN': 'Volver a ',
    'THANK_YOU': {
      'TITLE': 'Gracias',
      'BUTTON': 'VOLVER A LA PÁGINA PRINCIPAL',
      'BUTTON_LINK': 'SIGUIENTE'
    },
    'TEXTAREA': {
      'PLACEHOLDER': 'Teclear para agregar una idea'
    },
    'CHARACTERS_LEFT': 'caracteres restantes'
  },
  // === PARTICIPANT QUESTIONS ===
  // =============================
  'PARTICIPANT_QUESTIONS': {
    'TITLE': 'Preguntas para los participantes',
    'PAGE': 'Página',
    'OF': 'de',
    'FINISH': 'Completar',
    'BACK': 'Volver',
    'NEXT': 'Siguiente',
    'DECIMALS_ALLOWED': 'Se puede usar decimales hasta %0.',
    'RANGE': 'Min: %0 Max: %1',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Mostrar introducción',
      'LEAVE_QUESTIONS': 'Abandonar las preguntas',
      'FINISH_QUESTIONS': 'Terminar de contestar preguntas'
    },
    'TEXTAREA_PLACEHOLDER': 'Escriba una respuesta aquí.',
    'SELECT': 'Seleccione una opción',
    'HOLD_MODAL': {
      'TITLE': 'Espere',
      'DESCRIPTION': 'Debe contestar todas las preguntas requeridas para completar la actividad.',
      'BUTTON': 'CONTINUAR',
      'LEAVE_QUESTIONS_AND_RETURN_LATER': 'Dejar las preguntas para más adelante'
    },
    'INTRODUCTION_MODAL': {
      'TITLE': 'Preguntas para los participantes',
      'BUTTON': 'EMPEZAR'
    },
    'PROJECT_HOME': 'Página principal del proyecto',
    'RETURN': 'Volver a',
    'THANK_YOU': {
      'TITLE': 'Gracias',
      'BUTTON': 'VOLVER A LA PÁGINA PRINCIPAL',
      'BUTTON_LINK': 'SIGUIENTE'
    },
    'OOPS': {
      'TITLE': '¡Uy, perdón!',
      'MESSAGE': 'Para este proyecto no existen preguntas para participantes.'
    },
    'OTHER': {
      'DEFAULT': 'Otro',
      'PLACEHOLDER': 'Introducir una respuesta aquí'
    },
    'CHARACTERS_LEFT': 'caracteres restantes',
    'ERRORS': {
      'NUMERIC': 'La respuesta debe ser entre el valor mínimo y el máximo y no puede exceder el número de decimales indicado.'
    },
    'REQUIRED_FIELD': '*  indica campo obligatorio'
  },
  // ====== RATING ===========================
  // ==========================================
  'RATING': {
    'RATING': 'CALIFICACIÓN',
    'SHOW_INTRO': 'Mostrar introducción',
    'LEAVE_QUESTION': 'Abandonar las preguntas',
    'FINISH_QUESTION': 'Completar las preguntas',
    'FOCUS_PROMPT': 'LA PREGUNTA DE ENFOQUE',
    'FINISH': 'Terminar',
    'OF': 'de',
    'STATEMENTS': 'declaraciones',
    'RATED': 'clasificada(s)',
    'HIDE_PROMPT': 'Esconder la pregunta de enfoque',
    'IMPORTANCE': 'IMPORTANCIA',
    'CHOOSE_RATING': 'Escoja su calificación',
    'SELECT_RATING': 'SELECCIONAR LA CALIFICACIÓN',
    'DECIMALS_ALLOWED': 'No más de dos decimales.',
    'MIN': 'Mínimo',
    'MAX': 'Máximo',
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'EMPEZAR',
      },
      'FINISH': {
        'TITLE': 'Terminar actividad',
        'DESCRIPTION': 'El estado de esta actividad indica que ya se terminó.',
        'ACTIONS': {
          'CONTINUE': 'SEGUIR',
          'LINK': 'Dejar la calificación para más adelante'
        }
      }
    },
    'PROJECT_HOME': 'Página principal del proyecto',
    'RETURN': 'Volver a',
    'THANK_YOU': {
      'TITLE': 'Gracias',
      'BUTTON': 'Volver a la página principal',
      'BUTTON_LINK': 'SIGUIENTE'
    },
    'STATEMENTS_LIST': {
      'PAGE': 'Página',
      'OF': 'de',
      'STATEMENTS': 'declaraciones',
      'TO': 'a',
      'ON': 'en',
      'ON_PAGE': 'En esta página:',
      'ALL': 'Toda(s)',
      'UNRATED': 'No calificada(s)',
      'RATED': 'Calificada(s)',
      'BACK': 'VOLVER',
      'NEXT': 'SIGUIENTE'
    },
    'VALIDATION_ERROR': 'La calificación debe ser entre el valor mínimo y el máximo.',
    'UNRATE': 'Descalificar'
  },
  // ========== SORTING ==========
  // =============================
  'SORTING': {
    'TITLE': 'Ordenamiento',
    'CARDS': {
      'TITLE': 'Tarjetas',
      'MORE': 'más',
      'LESS': 'menos',
      'ALL': 'Todas',
      'UNSORTED': 'Desclasificados',
      'SORTED': 'Clasificados',
      'PILES': 'Pilas',
      'SORT_IN': 'Clasificar en',
      'IN_PILE': 'en pila',
      'UNIQUE': 'tarjeta',
      'MULTIPLE': 'tarjetas'
    },
    'INTRODUCTION': 'Arrastre y coloque tarjetas para crear pilas',
    'OF': 'de',
    'STATEMENTS': 'declaraciones',
    'SORTED': 'clasificadas',
    'AUTO_SAVE': 'Todos los cambios guardados',
    'FINISH': 'TERMINAR',
    'EXPAND_ALL': 'Ampliar todo',
    'COLLAPSE_ALL': 'Reducir todo',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Mostrar introducción',
      'SHOW_TOUR_AGAIN': 'Mostrar tour otra vez',
      'LEAVE_SORTING': 'Salir de el ordenamiento',
      'FINISH_SORTING': 'Terminar el ordenamiento'
    },
    'MODAL': {
      'LANDSCAPE': {
        'MESSAGE': 'Para una experiencia ideal, ponga su tableta en modo horizontal'
      },
      'INTRODUCTION': {
        'BUTTON': 'EMPEZAR'
      },
      'DELETE_PILE': {
        'TITLE': 'Borrar Pila',
        'DESCRIPTION': '¿Está seguro de querer borrar la pila seleccionada?',
        'BUTTONS': {
          'CANCEL': 'CANCELAR',
          'YES': 'SÍ'
        }
      },
      'FINISH': {
        'TITLE': 'Lo siento',
        'DESCRIPTION': 'Hay que clasificar por lo menos %0 de las tarjetas para terminar.',
        'ACTIONS': {
          'CONTINUE': 'SEGUIR',
          'LINK': 'Dejar la calificación para más adelante'
        }
      },
      'SORT_IN': {
        'NEW_PILE': 'NUEVA PILA',
        'PLACEHOLDER': 'Introducir un nombre',
        'NO_PILES': 'Ninguna pila ha sido creada todavía',
        'SORT': 'CLASIFICAR ',
        'SEND': 'ENVIAR',
        'CARD': 'TARJETA %0',
        'INTO': 'EN...',
        'TO_PILE': 'A PILA',
        'CREATE_NEW_PILE': '+ Crear nueva pila',
        'SAVE_NEW_PILE': 'Guardar',
        'CANCEL': '< Volver a declaraciones',
        'SAVE': 'GUARDAR',
        'SUCCESS': 'Tarjeta clasificada con éxito',
        'NAMING': '¡La nomenclatura de las pilas es importante!',
        'ERROR_HELPER_PILE_NAME': 'Hay que nombrar esta pila.'
      },
      'PILE': {
        'TITLE': 'PILA',
        'VIEW': 'Ver tarjetas en la pila',
        'EDIT': 'Modificar el nombre de la pila',
        'DELETE': 'Borrar la pila',
        'CANCEL': '< Volver a las pilas',
        'SAVE': 'GUARDAR',
        'CREATE': 'CCrear una nueva pila'
      }
    },
    'FOCUS_PROMPT': {
      'TITLE': 'LA PREGUNTA DE ENFOQUE:',
      'SUB_TITLE': 'Para desarrollar el bienestar nacional en nuestras comunidades y para nuestra gente, debemos...',
      'HIDE_PROMPT': 'Esconder la pregunta de enfoque'
    },
    'DROP': {
      'CREATE': 'Crear',
      'NEW': 'nueva pila'
    },
    'DELETE_PILE': 'borrar pila',
    'DROP_TO_CREATE': 'Soltar para crear',
    'NEW_PILE': 'nueva pila',
    'PILE_PLACEHOLDER': 'Entre el nombre de la pila',
    'PROJECT_HOME': 'Página principal',
    'RETURN': 'Volver a',
    'THANK_YOU': {
      'TITLE': 'Gracias',
      'BUTTON': 'VOLVER A LA PAGINA PRINCIPAL',
      'BUTTON_LINK': 'SIGUIENTE'
    },
    'REVIEW': {
      'TITLE': '¡Casi terminado!',
      'UNNAMED': 'Pilas sin nombre',
      'ALL_NAMED': '¡Se ha dado nombre a cada pila!',
      'ALL_NAMED_DESCRIPTION': 'Favor de seleccionar terminado para terminar la actividad.',
      'REVIEW': 'Repasar',
      'DONE': 'Terminado',
      'FINISH': 'Terminar sin dar nombre.',
      'BACK': 'Volver a la lluvia de ideas.',
      'ACTIONS': {
        'OK': 'Ok',
        'TRY_USING': 'Intenta usar',
        'OR': 'o',
        'SWITCH': 'para cambiar de pila'
      }
    },
    'PILES': {
      'NO_SORTED': 'Todavía ninguna declaración ha sido clasificada ni puesta en pila.'
    }
  },
  'HELP_SUPPORT': {
    'TITLE': 'Ayuda & apoyo',
    'SUBTITLE': '¿En qué podemos ayudarle?',
    'CONTACT': {
      'TECHNICAL': 'Apoyo técnico:',
      'SEND_MESSAGE': 'Envíenos su mensaje',
      'GET_BACK': '¡Le responderemos lo antes posible!',
      'PROJECT': 'PROYECTO',
      'EMAIL_PHONE': 'CORREO ELECTRÓNICO O TELÉFONO DEL CONTACTO',
      'OPTIONAL': 'Opcional',
      'TOPIC': 'TEMA',
      'ADDITIONAL_INFO': 'Información suplemental',
      'LET_US': 'Háganos saber con cuál actividad encuentra problema. Favor de darnos toda la información posible.',
      'SUCCESS': 'Su mensaje ha sido enviado.',
      'CONTACT_ERROR': 'Favor de verificar el correo electrónico o el número de teléfono.'
    },
    'MODAL': {
      'TITLE': 'El mensaje no ha podido ser enviado.',
      'TEXT': 'En nuestro registro no se encuentra contacto para este proyecto.',
      'CONTACT': 'Se puede ponerse en contacto con al apoyo técnico por teléfono o por correo electrónico @conceptsystems.com.',
      'OK': 'Ok'
    },
    'MOST_FREQUENT': 'Preguntas frecuentes',
    'PQ': 'Preguntas sobre el perfil de los participantes',
    'BS': 'Lluvia De Ideas',
    'TST': 'Ordenamiento de escritorio',
    'DST': 'Ordenamiento desplegable',
    'RT': 'Calificación',
    'CONTACT_US': 'Contáctenos',
    'FOR': 'por',
    'PLACEHOLDER': 'The Future Foundation'
  },
  'FIRST_LOGIN': {
    'LINKS': {
      'PRIVACY': 'Privacidad',
      'TERMS': 'Término'
    }
  },
  'FORMS': {
    'PASSWORD_REQUIREMENTS': {
      'TITLE': 'Una contraseña segura debe incluir por lo menos:',
    }
  },
  'LOCK': {
    'TITLE': 'Primero, complete todas las preguntas requeridas',
    'MESSAGE': 'Debe contestar todas las preguntas requeridas para completar la actividad. O puede dejarlas para más adelante.'
  },
  'BUBBLE': {
    'SKIP_INTRO': 'Omitir',
    'BACK': 'Volver',
    'NEXT': 'Siguiente',
    'DONE': 'Terminado'
  }
};

export const LANG_ES_TRANS = Object.assign(LANG_ES, COUNTRIES_ES);



// WEBPACK FOOTER //
// ./src/app/translation/i18n/lang-es.ts